import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { _ } from '@splunk/ui-utils/i18n';
import CaretSmallDown from '@splunk/react-icons/CaretSmallDown';
import CaretSmallRight from '@splunk/react-icons/CaretSmallRight';
import ScreenReaderContent from '@splunk/react-ui/ScreenReaderContent';
import { variables } from '@splunk/themes';
import type { Mode } from '@splunk/dashboard-types';
import { LINE_HEIGHT } from '../header/Title';

const TriangleContainer = styled.button`
    display: flex;
    align-items: center;
    height: ${LINE_HEIGHT};
    box-sizing: inherit;
    color: ${variables.contentColorDefault};
    background: none;
    cursor: pointer;
    border: 0;
    padding: 0;
    margin-left: -8px;
`;

const CaretSmallDownStyled = styled(CaretSmallDown)`
    pointer-events: auto;
`;

const CaretSmallRightStyled = styled(CaretSmallRight)`
    pointer-events: auto;
`;

export interface CollapseHandleProps {
    isExpanded: boolean;
    mode: Mode;
    description?: string;
    onClick: () => void;
}

export const CollapseHandle = forwardRef<
    HTMLButtonElement,
    CollapseHandleProps
>(({ isExpanded, mode, description, onClick }, ref): JSX.Element | null => {
    if (mode !== 'view' || !description) {
        return null;
    }
    return (
        <TriangleContainer ref={ref} onClick={onClick}>
            {isExpanded ? (
                <>
                    <CaretSmallDownStyled data-test="triangle-header-expanded" />
                    <ScreenReaderContent>{_('Show less')}</ScreenReaderContent>
                </>
            ) : (
                <>
                    <CaretSmallRightStyled data-test="triangle-header-collapsed" />
                    <ScreenReaderContent>{_('Show more')}</ScreenReaderContent>
                </>
            )}
        </TriangleContainer>
    );
});
